import React, { useState } from "react";
import { FiActivity, FiMapPin, FiCpu, FiDroplet, FiUser, FiFileText } from "react-icons/fi";
import { MdOutlineSpeed } from "react-icons/md";
import { fleetDummyData } from "../../Data/FleetData";
import { DashboardHeader } from "../../components/Shared";
import FleetOverviewPanel    from "./panels/FleetOverviewPanel";
import TrackingPanel         from "./panels/TrackingPanel";
import TelemetryPanel        from "./panels/TelemetryPanel";
import FleetPredictivePanel  from "./panels/FleetPredictivePanel";
import FuelCostPanel         from "./panels/FuelCostPanel";
import DriverPanel           from "./panels/DriverPanel";
import CompliancePanel       from "./panels/CompliancePanel";
import "../Dashboard.css";
import "./FleetDashboard.css";

const TABS = [
  { id: "overview",   label: "Overview",       icon: FiActivity },
  { id: "tracking",   label: "Live Tracking",  icon: FiMapPin },
  { id: "telemetry",  label: "Telemetry",      icon: MdOutlineSpeed },
  { id: "predictive", label: "Predictive AI",  icon: FiCpu },
  { id: "fuel",       label: "Fuel & Cost",    icon: FiDroplet },
  { id: "drivers",    label: "Driver Behavior", icon: FiUser },
  { id: "compliance", label: "Compliance",     icon: FiFileText },
];

const FleetDashboard = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const d = fleetDummyData;

  const renderPanel = () => {
    switch (activeTab) {
      case "overview":   return <FleetOverviewPanel   d={d} />;
      case "tracking":   return <TrackingPanel        d={d} />;
      case "telemetry":  return <TelemetryPanel       d={d} />;
      case "predictive": return <FleetPredictivePanel d={d} />;
      case "fuel":       return <FuelCostPanel        d={d} />;
      case "drivers":    return <DriverPanel          d={d} />;
      case "compliance": return <CompliancePanel      d={d} />;
      default:           return null;
    }
  };

  return (
    <div className="fm-container">
      <DashboardHeader currentSolutionType="fleet" />

      {/* Tab Bar */}
      <div className="fm-tab-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`fm-tab ${activeTab === tab.id ? "fm-tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <tab.icon size={16} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Panel Content */}
      <div className="fm-panel">
        {renderPanel()}
      </div>
    </div>
  );
};

export default FleetDashboard;
